var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKefu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3D6BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0182 25.613L18.2668 21.8579L25.0845 15.7148C25.3864 15.4396 25.0224 15.3065 24.6229 15.5461L16.2073 20.8636L12.5676 19.7096C11.7864 19.4877 11.7775 18.9461 12.7451 18.5555L26.9221 13.0871C27.5702 12.7942 28.1916 13.2469 27.943 14.2412L25.5284 25.613C25.3597 26.4208 24.8715 26.6161 24.1968 26.2432L20.5216 23.5268L18.755 25.2401C18.5509 25.4443 18.3822 25.613 18.0182 25.613Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKefu2);
export default __webpack_public_path__ + "static/media/kefu2.1c56a8139848beb3251235381e849d82.svg";
export { ForwardRef as ReactComponent };